import type { FilterListProps } from './types';
import { chipListGenerator } from './chipListGenerator';
import { InputKeywordSearch } from './InputKeyworkdSearch/InputKeywordSearch';
import { useSearchBar } from './hooks/useSearchBar';
import { HorizontalRadioList } from './components/HorizontalRadioList';
import { HorizontalChipList } from './components/HorizontalChipList';
import { Flex } from '@banhala/ui-kit';

export const FilterList = ({
  body,
  logging,
  scrollToFilterList,
}: FilterListProps) => {
  const searchChip = body.chip?.chip_list.find(chip => chip.type === 'search');

  const {
    isSearchBarOpen,
    toggleSearchBar,
    inputValue,
    setInputValue,
    closeFilterList,
  } = useSearchBar({
    searchChip,
    scrollToFilterList,
  });

  const filterChips = (() => {
    if (body.chip?.chip_list == null) return [];
    return chipListGenerator(body.chip.chip_list);
  })();

  return (
    <Flex backgroundColor="white">
      {body.radio != null && (
        <Flex borderBottomWidth={1} borderColor="border_tertiary">
          <HorizontalRadioList
            radioFilter={body.radio}
            logging={logging}
            scrollToFilterList={scrollToFilterList}
          />
        </Flex>
      )}

      {filterChips.length > 0 && (
        <Flex borderBottomWidth={1} borderColor="border_tertiary">
          <HorizontalChipList
            filterChips={filterChips}
            showResetChip={body.chip?.refreshable ?? false}
            isSearchBarOpen={isSearchBarOpen}
            toggleSearchBar={toggleSearchBar}
            closeSearchBar={closeFilterList}
            logging={logging}
            scrollToFilterList={scrollToFilterList}
            radioQueryName={body.radio?.query_name}
          />
          {isSearchBarOpen && (
            <InputKeywordSearch
              inputValue={inputValue}
              setInputValue={setInputValue}
              placeholder={searchChip?.search_hint}
              logging={logging}
              closeFilterList={closeFilterList}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};
